import get from 'lodash/get';

import { RULES } from '../../../utils/validations';
import { FIELDS_TYPE } from '../../../constants';

export default (employers = {}, formatMessage) => {
  const prefixID = formatMessage({ id: 'common.ID' });
  const employeeEmployers = employers ? employers.employeeEmployers : [];
  const { startTime, endTime, timeZone } = get(employers, 'workingHours', {});
  const result = [];

  const locations = employeeEmployers.map(item => {
    const employeeType = get(item, 'employersEmployeeType.name', '');
    const fullEmployeeType = employeeType ? `, ${employeeType}` : '';
    return {
      name: item.employer.name,
      value: `${prefixID}: ${item.externalId}${fullEmployeeType}`,
      disabled: true,
    };
  });
  const workingHours = employeeEmployers.map(() => {
    return {
      name: formatMessage({ id: 'profile.section.workingHours' }),
      value: [startTime, endTime, { label: timeZone, value: timeZone }],
      fieldName: 'workingHours',
      type: FIELDS_TYPE.CUSTOM_TIME_PICKER,
      validationRules: {
        [RULES.WORKING_HOURS]: {
          message: 'profile.workingHours.required',
        },
      },
    };
  });

  for (let i = 0; i < employeeEmployers.length; i++) {
    result.push(locations[i]);
    result.push(workingHours[i]);
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/generateEmployersDescriptors.js